var _Circle, _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 8,
    cy: 8,
    r: 5.6,
    stroke: "#FFD24A",
    strokeWidth: 1.8
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    stroke: "#FFD24A",
    strokeLinecap: "round",
    strokeWidth: 2.1,
    d: "M12.3 12.3 17 17"
  })));
};
export default SvgSearch;